import type { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  navType: 'dev',
  BACKEND_API_BASE_URL: 'https://api.stoltdev.com/st-aeye-integration-appsvc',
  AAD_CLIENT_ID: "1f229cc3-b398-41a8-82fb-e4c9df3dafec",
  AAD_AUTHORITY: "https://login.microsoftonline.com/35d14ae1-4ee5-441b-a84a-6791dee05c7b",
  AAD_REDIRECT_URI: "https://aeye-dev.stolttankers.com",
  AAD_GRAPH_ENDPOINT: 'https://graph.microsoft.com/v1.0/me',
  AAD_USER_API_SCOPE: 'api://0150281d-5705-4bcc-a913-13b2bed82eb7/.default',
  POSTHOG_API_KEY:'phc_u47UkcnXr5j39dsCUKibxpkejSLrBHD53FKciceTvwLE',
  POSTHOG_API_HOST:'https://ph.stolt.com',
  POSTHOG_UI_HOST: 'https://eu.posthog.com',
  POSTHOG_API_DEFAULTS: '2026-05-25',
  POSTHOG_ENABLED_TRACKING:true
};
